<!-- Ported from the Polaris kit: src/product/components/ContactNote.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first. -->
<script setup>
// One note on a contact: who wrote it, when, and the words. The author can delete it, with one more question. Text keeps its line breaks.
import { useI18n } from 'vue-i18n';
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from '../ui/item';
import ConfirmButton from './ConfirmButton.vue';
import UserAvatar from './UserAvatar.vue';

defineProps({
  author: { type: String, required: true },
  time: { type: String, required: true },
  // Optional when the caller fills the named `#content` slot instead (e.g. a note body that needs
  // its own formatted-HTML container or a "show more" toggle) — the kit gallery keeps passing plain text.
  text: { type: String, default: '' },
  deletable: { type: Boolean, default: true },
});
const emit = defineEmits(['delete']);
const { t } = useI18n();
</script>

<template>
  <Item
    variant="outline"
    size="sm"
    class="flex-nowrap items-start"
    data-contact-note
  >
    <ItemMedia>
      <!-- The kit draws the author from initials only (UserAvatar has no thumbnail wired up here);
           a caller that has a real avatar image (the woot Avatar) overrides this via the slot. -->
      <slot name="avatar">
        <UserAvatar :name="author" :size="24" tinted decorative />
      </slot>
    </ItemMedia>
    <ItemContent class="min-w-0">
      <ItemTitle>
        {{ author
        }}<span
          class="type-polaris-caption font-normal text-polaris-muted-foreground"
          >{{ time }}</span
        >
      </ItemTitle>
      <slot name="content">
        <ItemDescription
          class="line-clamp-none whitespace-pre-line text-polaris-foreground"
        >
          {{ text }}
        </ItemDescription>
      </slot>
    </ItemContent>
    <ItemActions v-if="deletable">
      <ConfirmButton
        :label="t('POLARIS.CONTACT_NOTE.DELETE')"
        :question="t('POLARIS.CONTACT_NOTE.DELETE_CONFIRM')"
        variant="ghost"
        size="sm"
        @confirm="emit('delete')"
      />
    </ItemActions>
  </Item>
</template>
